import * as React from "react"

import { Button, Col, Container, Modal, Row } from "react-bootstrap"

import ActionButton from "./ActionButton"
import WarningImage from "../assets/images/warning.png"

interface ConfirmationModalProps {
  show: boolean
  showImage?: boolean
  title?: string
  textTitle?: string
  text?: string
  cancelButtonText?: string
  confirmButtonText?: string
  children?: React.ReactNode
  size?: "lg"
  disableConfirmButton?: boolean
  spinConfirmButton?: boolean
  disableConfirmOnSpin?: boolean
  showCancelButton?: boolean
  showCloseButton?: boolean
  onHide: () => void
  onConfirm: () => void
}

function ConfirmationModal({
  show,
  showImage = true,
  title = "CONFIRM",
  textTitle = "",
  text = "",
  cancelButtonText = "CANCEL",
  confirmButtonText = "CONFIRM",
  children = null,
  size = undefined,
  disableConfirmButton = false,
  spinConfirmButton = false,
  disableConfirmOnSpin = false,
  showCancelButton = true,
  showCloseButton = true,
  onHide,
  onConfirm,
}: ConfirmationModalProps) {
  return (
    <Modal backdrop="static" centered show={show} onHide={onHide} size={size}>
      <Modal.Header closeButton={showCloseButton}>
        <Modal.Title className="h5">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {children || (
          <Container fluid>
            <Row>
              {showImage && (
                <Col sm={2} className="d-flex justify-content-center align-items-center">
                  <img src={WarningImage} alt="Warning" width="50" />
                </Col>
              )}
              <Col className="d-flex">
                {textTitle && (
                  <h5 className="my-auto pt-0" style={{ whiteSpace: "pre-wrap" }}>
                    {textTitle}
                  </h5>
                )}
              </Col>
            </Row>
            {text && (
              <Row>
                {showImage && <Col sm={2} />}
                <Col>
                  <p className="mb-1">{text}</p>
                </Col>
              </Row>
            )}
          </Container>
        )}
      </Modal.Body>
      <Modal.Footer>
        {showCancelButton && (
          <Button variant="secondary" onClick={onHide} className="mr-auto fixed-w5">
            {cancelButtonText}
          </Button>
        )}
        <ActionButton
          variant="primary"
          onClick={onConfirm}
          disabled={disableConfirmButton}
          spin={spinConfirmButton}
          disableOnSpin={disableConfirmOnSpin}
          className="fixed-w5"
        >
          {confirmButtonText}
        </ActionButton>
      </Modal.Footer>
    </Modal>
  )
}

export default ConfirmationModal
